import { Suspense } from "react";
import { createFileRoute } from "@tanstack/react-router";

import { lazyChunk } from "@/compat/lazyChunk";
import { reportRoomChunk } from "@/components/room/roomChunkFailure";

/**
 * The demo: a clearing to walk around in, with nobody else in it.
 *
 * An address of its own because it is not a room — nothing is looked up,
 * nothing is written, and no channel is opened. It is the product showing
 * itself to one person, which is what the demo rooms on the server were for
 * until they stopped being worth a record each.
 *
 * Behind a chunk of its own: somebody who came to talk to their own people
 * should not download a demonstration to do it.
 */
const DemoRoom = lazyChunk(
  () => import("@/plugins/demo/DemoRoom"),
  "DemoRoom",
  "The demo",
  true,
  reportRoomChunk,
);

export const Route = createFileRoute("/demo")({
  component: () => (
    <Suspense fallback={null}>
      <DemoRoom />
    </Suspense>
  ),
});
